<template>
  <div class="section-itis9-promotion">
    <div class="title">
      <y-text size="32px">{{ getI18nText(promotionsData.titleI18n) }}</y-text>
    </div>

    <!-- 轮播容器 - 使用 Element Plus Carousel -->
    <el-carousel
      ref="carouselRef"
      class="promotion-carousel"
      :autoplay="true"
      :interval="4000"
      :loop="true"
      indicator-position="none"
      arrow="never"
      @change="handleCarouselChange"
    >
      <el-carousel-item v-for="(promotion, index) in promotions" :key="index">
        <div class="promotion-content">
          <div class="text-content">
            <y-text class="subtitle">
              {{ getI18nText(promotion.subtitleI18n) }}
            </y-text>

            <y-text class="description" v-if="getI18nText(promotion.descriptionI18n)">
              {{ getI18nText(promotion.descriptionI18n) }}
            </y-text>

            <y-button class="promotion-btn" @click="handlePromotionClick(promotion)">
              {{ getI18nText(promotion.buttonTextI18n) || 'Button' }}
            </y-button>
          </div>
          <el-image
            class="image-content"
            :src="promotion.backgroundImage"
            fit="cover"
            lazy
          />
        </div>
      </el-carousel-item>
    </el-carousel>

    <!-- 指示器 - 移到内容下方 -->
    <div class="carousel-indicators" v-if="promotions.length > 1">
      <span
        v-for="(promotion, index) in promotions"
        :key="index"
        class="indicator"
        :class="{ active: index === currentCarouselIndex }"
        @click="goToPromotion(index)"
      ></span>
    </div>
  </div>
</template>

<script setup>
import { useYChannelStoreHook } from "@consumerY/store/channel";
import { computed, ref } from "vue";

import { getI18nText } from "@/plugins/i18n";

const channelStore = useYChannelStoreHook();

// 获取活动数据
const promotionsData = computed(() => {
  return channelStore.configs?.pages?.Index?.specialPromotions || {};
});

// 获取活动列表数据
const promotions = computed(() => {
  const list = promotionsData.value.promotions || [];
  // 如果是旧数据结构（单个活动数组），转换为数组
  if (Array.isArray(list)) {
    return list;
  } else if (list && Object.keys(list).length > 0) {
    return [list];
  }
  return [];
});

// 当前轮播索引
const currentCarouselIndex = ref(0);

// carousel 组件的 ref
const carouselRef = ref(null);

// 轮播变化事件
const handleCarouselChange = (index) => {
  currentCarouselIndex.value = index;
};

// 跳转到指定活动
const goToPromotion = (index) => {
  if (carouselRef.value) {
    carouselRef.value.setActiveItem(index);
  }
};

// 点击活动按钮
const handlePromotionClick = (promotion) => {
  if (promotion.buttonLink) {
    window.open(promotion.buttonLink, "_blank");
  }
};

defineOptions({
  name: "Itis9Promotion"
});
</script>

<style lang="scss" scoped>
.section-itis9-promotion {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .title {
    --y-text-font-family: var(--y-title-font);
    margin-top: 90px;
    font-size: 50px;
    color: var(--y-text-color);
    text-align: center;
    margin-bottom: 48px;
    line-height: 1;
  }

  .promotion-carousel {
    width: 1080px;
    height: 370px;
  }

  .promotion-content {
    width: 100%;
    height: 370px;
    display: flex;

    .text-content {
      width: 50%;
      background-color: #faf7f3;
      padding: 50px 48px;
      position: relative;

      .subtitle {
        font-family: var(--y-title-font);
        font-weight: bold;
        font-size: 24px;
        color: #44290d;
        line-height: 38px;
        white-space: pre-line;
      }

      .description {
        font-family: SourceHanSerifCN, SourceHanSerifCN;
        font-weight: 400;
        font-size: 16px;
        color: #696969;
        display: block;
        margin-top: 20px;
      }

      .promotion-btn {
        position: absolute;
        bottom: 56px;
        left: 48px;
        height: 40px;
        border: 1px solid #44290d;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 14px;
        color: #44290d;
        line-height: 20px;
        background-color: transparent;
        transition: all 0.3s ease;
        display: inline-block;

        &:hover {
          background-color: #44290d;
          color: #faf7f3;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(68, 41, 13, 0.2);
        }
      }
    }

    .image-content {
      width: 50%;
    }
  }

  // 指示器 - 移到内容下方
  .carousel-indicators {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    margin-top: 32px;

    .indicator {
      width: 16px;
      height: 4px;
      background: #D8D8D8;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        background: #b0b0b0;
      }

      &.active {
        width: 16px;
        height: 4px;
        background: #000b1e;
      }
    }
  }
}
</style>
